import type { ReactElement } from 'react';
import NavigableTab from 'components/technical/NavigableTabs/NavigableTab';
import NavigableTabs from 'components/technical/NavigableTabs/NavigableTabs';

const ProfitAndLossDashboard = (): ReactElement => {
  return (
    <NavigableTabs fullHeight>
      <NavigableTab link="/app/portfolio/profit-loss/performance" text="Performance" />
      <NavigableTab link="/app/portfolio/profit-loss/attribution" text="Attribution" />
      <NavigableTab link="/app/portfolio/profit-loss/asset-contribution" text="Contribution by asset" />
      <NavigableTab link="/app/portfolio/profit-loss/daily-pnl" text="Daily P&L" />
      <NavigableTab link="/app/portfolio/profit-loss/unified-pnl" text="Unified P&L" />
    </NavigableTabs>
  );
};

export default ProfitAndLossDashboard;
